import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Edit, Eye, Filter, Calendar, User, MapPin } from 'lucide-react';
import { 
  interventions as interventionsData,
  centres,
  getUserById,
  getCentreById,
  getTypeInterventionById 
} from '../../data/mockData';

function ListeInterventions({ user }) {
  const [interventions, setInterventions] = useState(interventionsData);
  const [filtreStatut, setFiltreStatut] = useState('toutes');
  const [filtreCentre, setFiltreCentre] = useState('tous');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredInterventions = interventions.filter(intervention => {
    const matchStatut = filtreStatut === 'toutes' || intervention.statut === filtreStatut;
    const matchCentre = filtreCentre === 'tous' || intervention.centreId === parseInt(filtreCentre);
    const matchSearch = intervention.plaque.toLowerCase().includes(searchTerm.toLowerCase());
    
    return matchStatut && matchCentre && matchSearch;
  }).sort((a, b) => {
    if (a.datePrevu !== b.datePrevu) {
      return new Date(b.datePrevu) - new Date(a.datePrevu);
    }
    return a.heurePrevu.localeCompare(b.heurePrevu);
  });

  const getStatutLabel = (statut) => {
    const labels = {
      'planifiee': { text: 'Planifiée', class: 'badge-primary' },
      'en_cours': { text: 'En cours', class: 'badge-warning' },
      'terminee': { text: 'Terminée', class: 'badge-success' },
    };
    return labels[statut] || { text: statut, class: 'badge-secondary' };
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Interventions</h1>
          <p className="text-muted">Gestion des interventions</p>
        </div>
        {user.role === 'admin' && (
          <Link to="/interventions/nouvelle" className="btn btn-primary">
            <Plus size={20} />
            Nouvelle intervention
          </Link>
        )}
      </div>

      <div className="filters-bar">
        <input
          type="text"
          placeholder="Rechercher par plaque..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />

        <select
          value={filtreStatut}
          onChange={(e) => setFiltreStatut(e.target.value)}
          className="filter-select"
        >
          <option value="toutes">Tous les statuts</option>
          <option value="planifiee">Planifiée</option>
          <option value="en_cours">En cours</option>
          <option value="terminee">Terminée</option>
        </select>

        <select
          value={filtreCentre}
          onChange={(e) => setFiltreCentre(e.target.value)}
          className="filter-select"
        >
          <option value="tous">Tous les centres</option>
          {centres.map(centre => (
            <option key={centre.id} value={centre.id}>{centre.nom}</option>
          ))}
        </select>
      </div>

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Heure</th>
              <th>Plaque</th>
              <th>Type</th>
              <th>Centre</th>
              <th>Technicien</th>
              <th>Durée</th>
              <th>Statut</th>
              {user.role === 'admin' && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {filteredInterventions.map(intervention => {
              const type = getTypeInterventionById(intervention.typeInterventionId);
              const technicien = getUserById(intervention.technicienId);
              const centre = getCentreById(intervention.centreId);
              
              return (
                <tr key={intervention.id}>
                  <td>
                    <div className="flex items-center gap-1">
                      <Calendar size={16} className="icon-muted" />
                      {new Date(intervention.datePrevu).toLocaleDateString('fr-FR')}
                    </div>
                  </td>
                  <td><strong>{intervention.heurePrevu}</strong></td>
                  <td><strong>{intervention.plaque}</strong></td>
                  <td>
                    {type && (
                      <span 
                        className="type-badge" 
                        style={{ backgroundColor: type.couleur }}
                      >
                        {type.code}
                      </span>
                    )}
                  </td>
                  <td>
                    <div className="flex items-center gap-1">
                      <MapPin size={14} className="icon-muted" />
                      {centre?.nom}
                    </div>
                  </td>
                  <td>
                    <div className="flex items-center gap-1">
                      <User size={14} className="icon-muted" />
                      {technicien?.prenom} {technicien?.nom}
                    </div>
                  </td>
                  <td>
                    {intervention.dureeReelle ? (
                      <span className="text-success">{intervention.dureeReelle} min</span>
                    ) : (
                      <span className="text-muted">{intervention.dureeEstimee} min</span>
                    )}
                  </td>
                  <td>
                    <span className={`badge ${getStatutLabel(intervention.statut).class}`}>
                      {getStatutLabel(intervention.statut).text}
                    </span>
                  </td>
                  {user.role === 'admin' && (
                    <td>
                      <div className="actions-group">
                        <Link
                          to={`/interventions/${intervention.id}/modifier`}
                          className="btn btn-sm btn-secondary"
                          title="Modifier"
                        >
                          <Edit size={16} />
                        </Link>
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {filteredInterventions.length === 0 && (
        <div className="empty-state">
          <Filter size={48} className="icon-muted" />
          <p>Aucune intervention trouvée</p>
        </div>
      )}
    </div>
  );
}

export default ListeInterventions;

